// ColorAccessibilitySettings.jsx
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import styles from './ColorAccessibilitySettings.module.css';
import sidebarStyles from 'components/settings/AccessibilitySidebar.module.css';
import { useSubSite } from 'contexts/SubSiteContext'; // Hook pour vérifier le sous-site

const ColorAccessibilitySettings = ({ selectedOption, onChange }) => {

  const { isSubSite } = useSubSite();

  return (
    <div className={`${sidebarStyles.grid} ${styles.colorSettings}`}>
      <label
        className={`${sidebarStyles.gridItem} ${selectedOption === 'standard' ? sidebarStyles.selected : ''
          }`}
      >
        <input
          type="radio"
          name="colorAccessibility"
          value="standard"
          checked={selectedOption === 'standard'}
          onChange={() => onChange('standard')}
        />
        <span className={sidebarStyles.gridHeading}>Par défaut (thème clair)</span>

        <ul className={`list--none ${styles.colors}`}>
          <li className={styles.primaryUltraLight}></li>
          <li className={styles.primaryLight}></li>
          <li className={styles.primary}></li>
          <li className={styles.primaryDark}></li>
          <li className={styles.primaryUltraDark}></li>
        </ul>

        Thème couleur par défaut du site.
      </label>
      <label
        className={`${sidebarStyles.gridItem} ${selectedOption === 'blackTheme' ? sidebarStyles.selected : ''
          }`}
      >
        <input
          type="radio"
          name="colorAccessibility"
          value="blackTheme"
          checked={selectedOption === 'blackTheme'}
          onChange={() => onChange('blackTheme')}
        />
        <span className={sidebarStyles.gridHeading}>Contrasté (thème sombre)</span>

        <ul className={`list--none ${styles.colors}`}>
          <li className={styles.darkSecondaryLight}></li>
          <li className={styles.darkSecondary}></li>
          <li className={styles.darkSecondaryDark}></li>
          <li className={styles.darkSecondaryUltraDark}></li>
          <li className={styles.neutral}></li>
        </ul>
        Thème contrasté facilitant la lecture.
      </label>
      <label
        className={`${sidebarStyles.gridItem} ${selectedOption === 'daltonisme' ? sidebarStyles.selected : ''
          }`}
      >
        <input
          type="radio"
          name="colorAccessibility"
          value="daltonisme"
          checked={selectedOption === 'daltonisme'}
          onChange={() => onChange('daltonisme')}
        />
        <span className={sidebarStyles.gridHeading}>Daltonisme</span>

        <ul className={`list--none ${styles.colors}`}>
          <li className={styles.daltonismeSecondaryLight}></li>
          <li className={styles.daltonismeSecondary}></li>
          <li className={styles.daltonismeSecondaryDark}></li>
          <li className={styles.daltonismeSecondaryUltraDark}></li>
          <li className={styles.neutral}></li>
        </ul>


        Couleurs adaptées aux personnes ayant des difficultés à percevoir les couleurs.
      </label>
    </div >
  );
};

ColorAccessibilitySettings.propTypes = {
  selectedOption: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default ColorAccessibilitySettings;
